import React from 'react';


const Index = (props) => {

        let details = (key,value) => {
            return(
                <div style={{
                    display:'flex',
                    flex:1,
                    borderBottom:'1px solid var(--border-color)',
                    fontSize:13,
                    borderLeft:'1px solid var(--border-color)'
                }}>
                    <div style={{
                        width:100,
                        textAlign:'center',
                        padding:'10px 0px',

                    }}>
                        {key}
                    </div>
                    <div style={{flex:1,padding:'10px 20px',borderLeft:'1px solid var(--border-color)'}}>
                        {value}
                    </div>
                </div>
            )
        }
        let { vendor } = props;
        return (
            <div>
                <p style={{
                    fontWeight: 600,
                    borderBottom:'1px solid var(--border-color)',
                    padding:'10px 10px'
                }}>Vendor Details</p>
                <div style={{display:'flex',flex:1}}>
                    {details('Code',vendor.vendorId)}
                    {details('Quotaion Ref','-')}
                </div>
                <div style={{display:'flex',flex:1}}>
                    {details('Name',vendor.name)}
                    {details('Mobile',vendor.mobile?vendor.mobile:'-')}
                </div>
                {details('Address',`${vendor.address.address} , ${vendor.address.city},${vendor.address.pincode} ${vendor.address.state}` )}
                {details('Gstin',vendor.gstin)}
                {details('Pan',vendor.pan?vendor.pan:'-')}
                {details('Email',vendor.email?vendor.email:'-')}
            </div>
        )
}

export default Index;